module.exports = __webpack_public_path__ + "img/69000.45a08e2a.jpg";